import * as React from 'react';

import * as _ from 'lodash';
import * as Bluebird from 'bluebird';
import { v4 as UUID } from 'uuid';

import { makeStyles } from '@material-ui/core/styles';

import { Switch, Route, useParams, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import {
    Grid,
    Paper,
    Typography,
    AppBar, Tabs, Tab, Toolbar,
    Button, IconButton,
    FormControl, InputLabel, Select, MenuItem, TextField,
    Divider,
    Dialog, DialogTitle, DialogContent, DialogActions
} from '@material-ui/core';
import * as Icons from '@material-ui/icons';

import { AgGridReact, AgGridColumn } from 'ag-grid-react';

import { useSnackbar } from 'notistack';

import { LouverSelector, LouverSelectorProps } from '../louverSelector';
import { LayoutEntity, LayoutEntityProps } from '../layoutEntity';
import { LayoutGrid, LayoutGridProps } from '../layoutGrid';

import { useServiceClient, usePreferences } from '../contexts';
import { CatalogEntry } from '../../lib/serviceClient';

import * as Settings from '../contexts/settings';
import * as Services from '../../lib/services';
import { createWellspringServiceClient } from '../../lib/serviceClient';

import * as LouverSelectionService from '../../lib/services/louverSelection.selection';
import * as ConfigurationModelEntity from '../../lib/services/configuration.modelEntity';
import * as ConfigurationModelLayout from '../../lib/services/configuration.modelLayout';
import * as ConfigurationModelConstraint from '../../lib/services/configuration.modelConstraint';
import * as ConfigurationCore from '../../lib/services/configuration.core';
import * as ConfigurationLayout from '../../lib/services/configuration.projectionLayout';
import * as ConfigurationLayoutGrid from '../../lib/services/configuration.projectionLayoutGrid';
import * as ConfigurationIntegration from '../../lib/services/configuration.projectionIntegration';

import {
    LouverSelector as LouverSelectorXM, LouverSelectorRenderProps, useLouverSelectorXM,
    LouverSizing as LouverSizingXM, LouverSizingRenderProps, useLouverSizingXM,
    Entity as EntityXM, useEntityXM,
    Grid as GridXM, useGridXM,
    useDiagnosticXM
} from '../xm';

const styles = makeStyles((theme) => ({
    root: {
        // background: '#c6cacf'
    },
    grow: {
        flexGrow: 1
    },
    sizesToolbar: {
        alignItems: 'flex-start'
    },
    sizesToolbarHeader: {
        flexGrow: 1
    },
    formControl: {
        minWidth: 150,
        paddingBottom: theme.spacing(1)
    },
    paperContainer: {
        padding: theme.spacing(1)
    },
    entityContainer: {
        padding: theme.spacing(1),
        background: '#F2F3F4'
    },
    textarea: {
        // resize: 'vertical',
        fontSize: 8,
        overflow: 'auto',
        maxWidth: '100%',
        maxHeight: 400
        // whiteSpace: 'nowrap'
    },
    test: {
        padding: theme.spacing(2)
    }
}));

export function BatchTesting() {
    const classes = styles();

    const [ testRunning, startTest, stopTest, toggleTest ] = batchTestingXM();

    return (
        <React.Fragment>
            <Grid container xs={12} spacing={1} alignItems="flex-start">
                <Grid item xs={12}>
                    <Button variant="contained" color="primary" onClick={() => toggleTest()}>{testRunning ? 'Stop' : 'Start'} Test</Button>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

const batchTestingXM = () => {
    const [ settings ] = Settings.useSettings();

    const [ serviceClient, setServiceClient ] = React.useState<Services.ConfigurationModel.DataAccessServiceClient>();
    React.useEffect(() => {
        setServiceClient(createWellspringServiceClient(Services.ConfigurationModel.DataAccessServiceClient, settings.servicesUrl, 'nucleus.configuration.models.dataaccess'));
        console.log('service client set')
    }, [ settings ]);

    const [ runningInterval, setRunningInterval ] = React.useState<number>();

    const start = React.useCallback(() => {
        if (runningInterval)
            return;

        const updatedRunningInterval: number = setInterval(() => {
            serviceClient?.loadEntity('LV/LouverConfigurationSelector_Schema');
        }, 50) as any;

        setRunningInterval(updatedRunningInterval);
    }, [ serviceClient, runningInterval ]);
    const stop = React.useCallback(() => {
        clearInterval(runningInterval);
        setRunningInterval(undefined);
    }, [ runningInterval ]);

    const toggle = React.useCallback(() => {
        runningInterval ? stop() : start();
    }, [ runningInterval, start, stop ])

    const isRunning = !!runningInterval;

    return [ isRunning, start, stop, toggle ] as const;
}